function getApiBaseUrl() {
  return "https://api-arivu-rb.vrtta.green"; // Production API
}

const config = {
  version: "abc",
  apiUrl: getApiBaseUrl(),
};

export default config;